// Base Vuetify blueprint that other plugin configs can override.
export const vuetifyBase = {
    VField: {
        style: { '--v-field-border-width': '1px' },
    },
    VDataTableServer: {
        density: 'default',
    },
    VDialog: {
        contentClass: 'app-dialog-bordered',
    },
    VTabs: {
        sliderTransition: 'grow',
        sliderTransitionDuration: 500,
        grow: true,
    },
};
